import React from 'react';
import styled from 'styled-components';

import Fade from '@webtv/components/fade';

interface BackdropRootProps {
  styles?: string;
}

export const BackdropRoot = styled.div<BackdropRootProps>`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px);

  ${({ styles }) => styles && styles};
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean;
  styles?: { root?: string };
}

export const Backdrop: React.FC<Props> = (props: Props) => {
  const { children, open, styles, ...rest } = props;

  return (
    <Fade in={open} unmountOnExit>
      <BackdropRoot aria-hidden={true} styles={styles?.root} {...rest}>
        {children}
      </BackdropRoot>
    </Fade>
  );
};

export default Backdrop;
